






























import {Component, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import { Snackbar } from 'buefy/dist/components/snackbar';
import Navbar from '@/components/SignUp/Navbar.vue';
import {Action, Mutation, State} from 'vuex-class'; // @ is an alias to /src
import BInput from 'buefy/src/components/input/Input.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue';
import {MAFUser} from '@/store/User/types'; // @ is an alias to /src

/* tslint:disable:no-console */
/* tslint:disable:max-line-length */

@Component({
  components: {
    Navbar, BButton, BInput,
    BField,
  },
})
export default class SignIn extends Vue {
  @Action('Login') public Login: any;
  @State('self', {namespace: 'userState'}) public self: MAFUser | undefined;
  @Mutation('setSelf', {namespace: 'userState'}) public setSelf: any;

  public BASE_URL: string;
  public showSignIn: boolean;
  public email: string;
  public emailMessage: string = 'An email is required.';
  public password: string;
  public passwordMessage: string = 'A password is required.';
  public newuser: any;

  public isLoading: boolean;
  public attemptedSignin: boolean = false;
  public showEmailSent: boolean = false;
  public showErrorEmailSent: boolean = false;
  public showNotVerified: boolean = false;

  constructor() {
    super();
    this.BASE_URL = process.env.BASE_URL ? process.env.BASE_URL : '';
    this.showSignIn = false;
    this.isLoading = false;
    this.email = '';
    this.password = '';
    this.emailMessage = '';
    this.passwordMessage = '';
  }
  public async login() {
    this.showEmailSent = false;
    this.showErrorEmailSent = false;
    this.showNotVerified = false;
    this.isLoading = true;
    this.attemptedSignin = true;

    try {
      await this.Login({email: this.email, password: this.password});

      if (this.self) {
        this.setSelf(this.self);
      }
    } catch (error) {
      console.log(error);
      this.snackbarWithTimeout(error);
    }

    this.isLoading = false;
    return false;
  }

  public async resetPass(): Promise<any> {
    this.showEmailSent = false;
    this.showErrorEmailSent = false;

    try {
      await Vue.prototype.$auth.sendPasswordResetEmail(this.email);
      this.showEmailSent = true;
    } catch (e) {
      this.showErrorEmailSent = true;
      console.log(e);
    }
  }

  /*public async sendVerificationEmail(): Promise<any> {
    this.showNotVerified = false;
    this.showEmailSent = false;

    try {
      this.newuser.sendEmailVerification();
      this.showEmailSent = true;
    } catch (e) {
      this.showNotVerified = false;
      this.showEmailSent = false;
      console.log(e);
    }
  }*/

  public snackbarWithTimeout(error: any) {
    this.$snackbar.open({
      // duration: 5000,
      message: `${error}`,
      type: 'is-danger',
      position: 'is-bottom-left',
      indefinite: true,
      onAction: () => {
        if (`${error}` === 'Error: There is no user record corresponding to this identifier. The user may have been deleted.') {
          this.$router.push('/');
        }
      },
    });

    const self = this;
    setTimeout(() => {
      if (`${error}` === 'Error: There is no user record corresponding to this identifier. The user may have been deleted.') {
        self.$router.push('/');
      }
    }, 5000);
  }
}
